// extracted by mini-css-extract-plugin
module.exports = {"link-type-button":"button-module__link-type-button___2f5jq"};